/*
Created-by: XtroEdge AI
Updated-by: XtroEdge AI
Last modified: 2026-11-03T22:30:00+05:00
Intent: Names for the receipt submissions list and the approve / reject of a receipt.
*/
// public-api.ts
import { environment } from '../../environments/environment';
// Xano is gone from the dashboard. The keys below are only NAMES now: every request is routed by
// key through MicroApiService to the gateway, and nothing fetches these URLs. The prefix is not
// a reachable origin, and the interceptor refuses any request that starts with it.
export const REMOVED_BACKEND_PREFIX = 'xano-removed:';
const BASE_URL = REMOVED_BACKEND_PREFIX;
const AI_BASE_URL = `${environment.Ai_insight_apiUrl}`;
const AUTH_URL = `${BASE_URL}:t3u1HoXb`;
const AUTH_URL2 = `${BASE_URL}:AFDabxbQ`;

const CONTEST_URL = `${BASE_URL}:BB6HooOR`;

const SUBSCRIB_URL = `${BASE_URL}:p7cV6HxK`;
const DEVELOPER_URL = `${BASE_URL}:v5lydYLZ`;
const NOTIF_URL = `${BASE_URL}:Aw50otLs`;
const ANALYSIS_URL_Reports = `${BASE_URL}:BowSC_LT`;
const CLIENT_DASHBOARD = `${BASE_URL}:KVYQ1PW2`;
const TEST_SERVERSIDE_PAGINATION = `${BASE_URL}:nyeA1eF9`;


const PRIVACY_URL = `${BASE_URL}:zTQtGzbe`;
const QUIZ_URL = `${BASE_URL}:71iUzbDi`;
const COMMON_URL = `${BASE_URL}:W8nua2-z`;
const SECTOR_URL = `${BASE_URL}:h3prqsmw`;
const USER_MGMT_URL = `${BASE_URL}:yLDe0z5b`;
const DASHBOARD_CONTESTS_URL = `${BASE_URL}:oVl64uWz`;
const ACTIVITY_LOGS_URL = `${BASE_URL}:hVlpuC4-`;
// Campaign Companion (WhatsApp bot) API group.
const COMPANION_URL = `${BASE_URL}:jKhRtMpW`;
export const PublicApi = {
  // ── Campaign Companion (WhatsApp) ──
  COMPANION_NUMBERS_LIST: COMPANION_URL + '/whatsapp_numbers_list',
  COMPANION_NUMBER_TOGGLE: COMPANION_URL + '/whatsapp_number_toggle',
  COMPANION_NUMBER_REMOVE: COMPANION_URL + '/whatsapp_number_remove',
  COMPANION_SET_ENABLED: COMPANION_URL + '/whatsapp_admin_set_companion',
  // Account-level master switch (separate from the per-number toggles above).
  COMPANION_IS_ENABLED: COMPANION_URL + '/is_companion_enabled',
  COMPANION_ENABLE: COMPANION_URL + '/enable_campaign_companion',
  // Companion activity/audit log feed (GET, query params).
  COMPANION_LOGS: COMPANION_URL + '/whatsapp_logs',
  WHATSAPP_CONVERSATION_LOG: COMPANION_URL + '/whatsapp_conversation_log',
  WHATSAPP_PENDING_CONTESTS: COMPANION_URL + '/whatsapp_pending_contests',
  LOGIN: AUTH_URL + '/auth/login',
  SIGNUP: AUTH_URL + '/auth/signup',
  SOCIAL_LOGIN: AUTH_URL + '/auth/google/continue',
  RESET_PASSWORD: AUTH_URL + '/reset-password',
  USER_RESET_PASSWORD: AUTH_URL + '/auth/reset_password',
  SEND_RESET_LINK: AUTH_URL + '/forgot_password',
  GET_PRIVACY_POLICY: PRIVACY_URL + '/privacy_policy',
  GET_TERMS_CONDITION: PRIVACY_URL + '/terms_condition',
  LOGOUT: AUTH_URL + '/auth/admin/logout',
  SEND_OPT: AUTH_URL + '/auth/send-client-otp',
  VERIFY_OPT: AUTH_URL + '/auth/verify-client-otp',
  GET_ME: AUTH_URL + '/auth/me',
  UPDATE_LANGUAGE: AUTH_URL + '/auth/language',
  SET_COMPANY_DETAILS: AUTH_URL2 + '/company_as_client',

  REQUEST_CONTEST_REMOVE_LEVEL: CONTEST_URL + '/levels',
  REQUEST_CONTEST_REMOVE_PRIZE: CONTEST_URL + '/contest_prize',

  GET_USER_COMPANY: AUTH_URL2 + '/all_company',
  GET_ALL_CONTESTS: CONTEST_URL + '/all_contests',
  REQUEST_CONTEST_CLIENT: CONTEST_URL + '/request_contest_client',
  SAVE_CONTEST_DRAFT: CONTEST_URL + '/save_contest_draft',
  // No legacy URL: the copy is made by the microservice (2388). The key only names the call.
  DUPLICATE_CONTEST: CONTEST_URL + '/duplicate_contest',
  REQUEST_CONTEST_LUQTA: TEST_SERVERSIDE_PAGINATION + '/request_contest',
  TEST_PAGINATION: TEST_SERVERSIDE_PAGINATION + '/get_contests',
  DELETE_CONTEST: CONTEST_URL + '/contest/remove',
  GET_SINGLE_CONTEST: CONTEST_URL + '/contest',
  // ── Web QR (per-contest QR instances) ──
  QR_INSTANCE_LIST: CONTEST_URL + '/qr_instance_list',
  QR_INSTANCE_CREATE: CONTEST_URL + '/qr_instance_create',
  QR_INSTANCE_UPDATE: CONTEST_URL + '/qr_instance_update',
  WEB_QR_INSTANCE_PARTICIPANTS: ANALYSIS_URL_Reports + '/WebQRInstanceParticipants',
  // Self-publish for web_access plans — the Web QR equivalent of PUBLISH_CONTEST.
  WEB_QR_SELF_APPROVE: CONTEST_URL + '/web_qr_self_approve',
  REQUEST_CONTEST_SET_LEVEL: CONTEST_URL + '/request_contest/set_level',
  REQUEST_CONTEST_SET_PRIZE: CONTEST_URL + '/request_contest/set_prize',
  // ── Prize pool (vouchers / gift cards) ──
  // Deliberately separate from the contest save: that endpoint rewrites every
  // prize field from whatever the browser sends, so a caller that predates this
  // feature would silently wipe a voucher code on its next save.
  CONTEST_PRIZE_POOL: CONTEST_URL + '/contest_prize_pool',
  CONTEST_PRIZE_CONFIG: CONTEST_URL + '/contest_prize_config',
  CONTEST_PRIZE_CODES: CONTEST_URL + '/contest_prize_codes',
  CATEGORIES_LOOKUP: CONTEST_URL + '/categories_lookup',
  CONTEST_CATEGORY_LOOKUP: CONTEST_URL + '/user_interest',
  CONTEST_OVERVIEW: CONTEST_URL + '/contest_over_view',
  PUBLISH_CONTEST: CONTEST_URL + '/publish_client_contest',
  WINNER_OVERRIDE: CONTEST_URL + '/winner_override',
  WINNER_OVERRIDE_AUDIT_LOG: CONTEST_URL + '/winner_override_audit_log',

  // sssss
  GET_Total_PARTICIPANT: CONTEST_URL + '/get_total_participates_client',

  PURCHASED_PLAN: SUBSCRIB_URL + '/user/purchased_plan',

  FREE_PLAN: SUBSCRIB_URL + '/freePlan',
  CHOOSE_SUBSCRIPTION_PLAN: SUBSCRIB_URL + '/subscribe_user',
  GET_SUBSCRIPTION_PLAN: SUBSCRIB_URL + '/active_plans',
  GET_BILLING_PLANS: SUBSCRIB_URL + '/billing_payment',
  CHECK_PAYMENT: SUBSCRIB_URL + '/check_payment',
  RENEWAL_PAYMENT_LINK: SUBSCRIB_URL + '/renewal_payment_link',
  CASH_PAYMENT: SUBSCRIB_URL + '/cashpayment',
  BANK_CARD: SUBSCRIB_URL + '/bank_card',
  EDIT_BANK_CARD: SUBSCRIB_URL + '/bank_card/edit',
  DELETE_BANK_CARD: SUBSCRIB_URL + '/bank_card/delete',
  PAYMENT_REPORT: SUBSCRIB_URL + '/billing/report',
  CHECK_PAYMENT_BY_USER: SUBSCRIB_URL + '/check_payment_by_user',
  ENTERPRISE_PLAN: SUBSCRIB_URL + '/enterprise',
  BILLING_DISCOUNT: SUBSCRIB_URL + '/get_discount_history',
  INVOICE_DETAILS: SUBSCRIB_URL + '/invoice_details',
  MY_SUBSCRIPTION: SUBSCRIB_URL + '/user_subscription',
  SUBSCRIPTION_HISTORY: SUBSCRIB_URL + '/plan_History',
  CHANGE_PLAN: SUBSCRIB_URL + '/sub/change_plan',
  CANCEL_SUBSCRIPTION: SUBSCRIB_URL + '/subscription',

  // SDK Applications
  SDK_APPLICATIONS: SUBSCRIB_URL + '/applications',
  SDK_APPLICATIONS_LIST: SUBSCRIB_URL + '/user_applications_list',
  SDK_GENERATE_API_KEY: SUBSCRIB_URL + '/generate_api_key',
  CHECK_SDK_PAYMENT: SUBSCRIB_URL + '/check_sdk_payment',

  // Web QR plans — a separate product from the main plan
  WEB_QR_PLANS: SUBSCRIB_URL + '/web_qr/plans',
  WEB_QR_SUBSCRIBE: SUBSCRIB_URL + '/web_qr/subscribe',
  WEB_QR_RENEW: SUBSCRIB_URL + '/web_qr/renew',
  WEB_QR_CONFIRM_PAYMENT: SUBSCRIB_URL + '/web_qr/confirm_payment',
  WEB_QR_CASH_PAYMENT: SUBSCRIB_URL + '/web_qr/cash_payment',
  WEB_QR_MY_SUBSCRIPTION: SUBSCRIB_URL + '/web_qr/my_subscription',

  GET_DEVELOPER_API_KEY: DEVELOPER_URL + '/third_party_user_api_keys',
  GET_NOTIFICATION: NOTIF_URL + '/notif',
  UPDATE_NOTIFICATION: NOTIF_URL + '/notification_update_client',
  MARK_ALL_NOTIFICATIONS_READ: NOTIF_URL + '/mark_allnotifications_read',
  BASE_TO_IMAGE: NOTIF_URL + '/baseToImage',

  // Analysis
  ANALYSIS_URL_Reports: ANALYSIS_URL_Reports + '/Contest_Summary_Client',
  ANALYSIS_URL_Reports_DETAIL: ANALYSIS_URL_Reports + '/individual_contest_report_client',

  // dashboard
  DASH_COUNTRY_DATA: CLIENT_DASHBOARD + '/country_data',
  DASH_CONTEST_STATS: CLIENT_DASHBOARD + '/get_contest_stats',
  DASH_LINE_CHART: CLIENT_DASHBOARD + '/line_chart',
  DASH_PARTICIPANTS: CLIENT_DASHBOARD + '/participants_data',
  // Gateway-only (2356): the Receipt Verification card.
  DASH_RECEIPT_STATS: CLIENT_DASHBOARD + '/receipt_stats',
  // The dashboard's Web QR dataset (the Simple / Web QR switch). Same sections as above, read
  // from the qr_* endpoints. No gateway action yet — see NOT_ON_GATEWAY in micro-api.service.
  DASH_QR_STATS: CLIENT_DASHBOARD + '/qr_stats',
  DASH_QR_PARTICIPANTS: CLIENT_DASHBOARD + '/qr_participants',
  DASH_QR_LINE_CHART: CLIENT_DASHBOARD + '/qr_line_chart',
  DASH_QR_COUNTRY_DATA: CLIENT_DASHBOARD + '/qr_country_data',

  // Branches (client outlets that carry QR codes) + the client's API key
  // Branches are split across two Xano groups:
  //   list / update / delete -> DCGxnpjI (unsuffixed, no X-Data-Source)
  //   create                 -> KVYQ1PW2 (env suffix, needs X-Data-Source)
  CLIENT_QR_REGISTER: CLIENT_DASHBOARD + '/client_qr_register',
  // QR levels this client has already registered, listed under the QR
  // Registration tab on the Branches screen.
  CLIENT_QR_MY_REGISTRATIONS: CLIENT_DASHBOARD + '/client_qr/my_registrations',
  CLIENT_API_KEY: CLIENT_DASHBOARD + '/client_api_key',
  SUBSCRIPTION_DETAIL: CLIENT_DASHBOARD + '/subscription_detail',
  DASH_CONTEST_OVERVIEW: CLIENT_DASHBOARD + '/Contest_Overview',
  // Web QR scan reporting — filtered by contest, label and date range, paginated.
  WEB_QR_REPORT: CLIENT_DASHBOARD + '/web_qr_report',
  CONTEST_DETAIL_OVERVIEW: CLIENT_DASHBOARD + '/contest_detail_overview',
  GET_ALL_PARTICIPANTS: CLIENT_DASHBOARD + '/participants',
  ALL_PARTICIPANTS: CLIENT_DASHBOARD + '/all_participants',
  UNIQUE_PARTICIPANTS: CLIENT_DASHBOARD + '/unique_participants',
  UNIQUE_PARTICIPANTS_V2: CLIENT_DASHBOARD + '/unique_participants_v2',
  UNIQUE_CONTEST_PARTICIPANTS: CLIENT_DASHBOARD + '/unique_contest_participants',
  UNIQUE_PARTICIPANTS_CONTEST_LEVELS: CLIENT_DASHBOARD + '/unique_participants_contest_levels',
  CONTEST_LEVEL_COMPLETION_METRICS: CLIENT_DASHBOARD + '/contest_level_completion_metrics',
  // AI INSIGHT APIS

  // GET_AI_INSIGHT: AI_BASE_URL + '/insights',

  // Quiz APIs
  GET_QUIZZES: QUIZ_URL + '/quizzes_client',
  GET_QUIZ_BY_ID: QUIZ_URL + '/quizzes',
  QUIZ_UPSERT: QUIZ_URL + '/quiz_upset',
  DELETE_QUIZ: QUIZ_URL + '/quizzes',
  GET_QUIZZES_LOOKUP: QUIZ_URL + '/quizzes_look_up_client',

  // Common/Lookup APIs
  GET_COUNTRIES: COMMON_URL + '/country',

  // Sector APIs
  GET_SECTORS: SECTOR_URL + '/sector',

  // User Management APIs
  CREATE_SUBUSER: USER_MGMT_URL + '/create/my/subusers',
  GET_SUBUSERS: USER_MGMT_URL + '/get/my/subusers',
  DELETE_SUBUSER: USER_MGMT_URL + '/delete_subuser',
  VERIFY_SUBUSER_PASSWORD: USER_MGMT_URL + '/verify_subuser_password',
  UPDATE_SUBUSER_PASSWORD: USER_MGMT_URL + '/update_subuser_password__',
  UPDATE_SUBUSER: USER_MGMT_URL + '/update_subuser',

  // Subuser Page Permissions APIs (Policy Management → Pages)
  CLIENT_PAGES: USER_MGMT_URL + '/client_pages',
  // Same Xano URL as CLIENT_PAGES; separate keys so the gateway can give create/edit and delete their own action.
  CLIENT_PAGES_SAVE: USER_MGMT_URL + '/client_pages',
  CLIENT_PAGES_DELETE: USER_MGMT_URL + '/client_pages',
  SUBUSER_PERMISSIONS: USER_MGMT_URL + '/subuser_permissions',
  SUBUSER_PERMISSIONS_BULK: USER_MGMT_URL + '/subuser_permissions_bulk',
  MY_PERMISSIONS: USER_MGMT_URL + '/my_permissions',
  // GET → { total, enabled_count, items: [{ sub_user_id, companion_enabled, phone_verified, can_connect, linked_numbers, verified_numbers, ... }] }
  // (all of the admin's sub-users when sub_user_id is omitted). POST { sub_user_id, companion_enabled } toggles one.
  SUBUSER_WHATSAPP_PERMISSION: USER_MGMT_URL + '/subuser_whatsapp_permission',
  // The write half of the same Xano URL, under its own key so the gateway can give it its own action.
  SUBUSER_WHATSAPP_PERMISSION_UPDATE: USER_MGMT_URL + '/subuser_whatsapp_permission',

  // Client Roles & Permissions APIs (Policy Management → Roles)
  GET_SUB_USERS_BY_PARENT: USER_MGMT_URL + '/get_sub_users',
  CLIENT_ROLES: USER_MGMT_URL + '/client_roles',
  // Same Xano URL as CLIENT_ROLES; separate keys so the gateway can give each verb its own action.
  CLIENT_ROLES_CREATE: USER_MGMT_URL + '/client_roles',
  CLIENT_ROLES_UPDATE: USER_MGMT_URL + '/client_roles',
  CLIENT_ROLES_DELETE: USER_MGMT_URL + '/client_roles',
  CLIENT_ROLE_PERMISSIONS: USER_MGMT_URL + '/client_role_permissions',
  CLIENT_ROLE_PERMISSIONS_BULK: USER_MGMT_URL + '/client_role_permissions_bulk',
  ASSIGN_SUBUSER_ROLE: USER_MGMT_URL + '/assign_subuser_role',

  // Dashboard Contests
  GET_DASHBOARD_CONTESTS: DASHBOARD_CONTESTS_URL + '/get_contests',
  GET_BUSINESS_SUBJECTS: DASHBOARD_CONTESTS_URL + '/business_subject',
  CONTEST_LEADERBOARD: DASHBOARD_CONTESTS_URL + '/contest_leaderboard',
  GLOBAL_LEVEL_SETTINGS: DASHBOARD_CONTESTS_URL + '/global_level_settings',

  // Activity Logs
  ACTIVITY_LOGS: ACTIVITY_LOGS_URL + '/create_activity_log_for_client',

  // Client Branding & Domain APIs
  BRANDING_LIST: CLIENT_DASHBOARD + '/branding/list',
  BRANDING_CREATE: CLIENT_DASHBOARD + '/branding/create',
  BRANDING_UPDATE: CLIENT_DASHBOARD + '/branding/update',
  BRANDING_SET_DEFAULT: CLIENT_DASHBOARD + '/branding/set_default',
  DOMAIN_LIST: CLIENT_DASHBOARD + '/domain/list',
  DOMAIN_CREATE: CLIENT_DASHBOARD + '/domain/create',
  DOMAIN_UPDATE: CLIENT_DASHBOARD + '/domain/update',
  DOMAIN_VERIFY: CLIENT_DASHBOARD + '/domain/verify',
  DOMAIN_DELETE: CLIENT_DASHBOARD + '/domain/delete',

  // 3D Models — upload is multipart/form-data (`content` file + `name`), list is per-user.
  UPLOAD_MODEL: CLIENT_DASHBOARD + '/upload/model',
  MY_MODELS: CLIENT_DASHBOARD + '/my_models',

  // ── policy management (2361-2367) ────────────────────────────────────────
  // These exist ONLY on the gateway — there is no Xano endpoint behind them, because the
  // feature is new rather than ported. They are still declared here because PublicApiKeys is
  // `keyof typeof PublicApi`, so a key absent from this object cannot be passed to
  // pagesService at all. The URLs are never requested: PagesService asks micro.handles() first
  // and every one of these is in the ACTION map, so it returns before touching PublicApi.
  POLICY_PAGES: CLIENT_DASHBOARD + '/policy/pages',
  POLICY_LIST: CLIENT_DASHBOARD + '/policy/list',
  POLICY_SAVE: CLIENT_DASHBOARD + '/policy/save',
  POLICY_DELETE: CLIENT_DASHBOARD + '/policy/delete',
  POLICY_ASSIGN: CLIENT_DASHBOARD + '/policy/assign',
  POLICY_OF_USER: CLIENT_DASHBOARD + '/policy/user',
  MY_PAGES: CLIENT_DASHBOARD + '/policy/my_pages',

  // ── audit records (2463-2464) ────────────────────────────────────────────
  // Gateway-only, like the policy keys above.
  CONTEST_AUDIT_RECORDS: CLIENT_DASHBOARD + '/contest/audit_records',
  CONTEST_AUDIT_EXPORT: CLIENT_DASHBOARD + '/contest/audit_export',

  // ── receipt submissions: review a receipt level's uploads ─────────────────
  // No gateway action yet; answered in the browser (see NOT_ON_GATEWAY in micro-api.service.ts).
  CONTEST_RECEIPT_SUBMISSIONS: CLIENT_DASHBOARD + '/contest/receipt_submissions',
  CONTEST_RECEIPT_REVIEW: CLIENT_DASHBOARD + '/contest/receipt_review',

  // ── campaign budget alerts (2465-2466) ───────────────────────────────────
  // Gateway-only, like the policy keys above.
  CONTEST_BUDGET_STATUS: CLIENT_DASHBOARD + '/contest/budget_status',
  CONTEST_BUDGET_ALERT_SET: CLIENT_DASHBOARD + '/contest/budget_alert',

  // ── AI Insight report for a date range (2467) ────────────────────────────
  // Gateway-only, like the policy keys above.
  CLIENT_INSIGHT_REPORT: CLIENT_DASHBOARD + '/insight/report',

  // ── Live Dashboard (2489-2495) ───────────────────────────────────────────
  // Gateway-only, like the policy keys above.
  MARKETING_PERIODS: CLIENT_DASHBOARD + '/marketing/periods',
  MARKETING_PERIOD_SAVE: CLIENT_DASHBOARD + '/marketing/period_save',
  MARKETING_PERIOD_DELETE: CLIENT_DASHBOARD + '/marketing/period_delete',
  MARKETING_OVERVIEW: CLIENT_DASHBOARD + '/marketing/overview',
  MARKETING_CAMPAIGN_DETAIL: CLIENT_DASHBOARD + '/marketing/campaign_detail',
  MARKETING_OBJECTIVES: CLIENT_DASHBOARD + '/marketing/objectives',
  MARKETING_LEVEL_OBJECTIVE_SET: CLIENT_DASHBOARD + '/marketing/level_objective',
  MARKETING_CAMPAIGNS: CLIENT_DASHBOARD + '/marketing/campaigns',

  // ── vouchers (2378-2383) ─────────────────────────────────────────────────
  // Gateway-only, like the policy keys above: declared so pagesService accepts the key, never
  // requested over HTTP because every one is in the ACTION map.
  VOUCHER_CREATE: CLIENT_DASHBOARD + '/voucher/create',
  VOUCHER_LIST: CLIENT_DASHBOARD + '/voucher/list',
  VOUCHER_BATCHES: CLIENT_DASHBOARD + '/voucher/batches',
  VOUCHER_USAGE: CLIENT_DASHBOARD + '/voucher/usage',
  VOUCHER_VOID: CLIENT_DASHBOARD + '/voucher/void',
  VOUCHER_CURRENCIES: CLIENT_DASHBOARD + '/voucher/currencies',
  VOUCHER_BUDGET: CLIENT_DASHBOARD + '/voucher/budget',
  VOUCHER_BUDGET_REQUEST: CLIENT_DASHBOARD + '/voucher/budget/request',

} as const;

// export const productDetails  = 'api/v1/product/';
